import PageAbstract from '../PageAbastract'
import store from '@/store'
import { BILL_TYPES } from '@/class/cargo/model/parameters/BillType'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache } from '@/utils/cacheManager'
import { loadSpecificBasicInfo } from '@/api/cache'
import { Voyage } from '@/class/model/mdm/Voyage'
import { getGuaranteeStateInfo } from '@/api/seaExport/seaCargoDoc'
import { getObjectByCache } from '@/utils/basicDataCache'

const isZh = store.getters.language === 'zh'

export default class SeaBookingHbl extends PageAbstract {
  constructor(job, formData) {
    super(job, formData)
    this.editVesselVoyageMode = Number(cache.config.get('EditVesselVoyageMode'))
    this.editVoyageMode = Number(cache.config.get('EditVoyageMode'))
    this.showJudgmentOfVoyageNo = Number(cache.config.get('JudgmentOfVoyageNo')) === 1
    this.vesselList = null
  }

  async loadElement(elementName) {
    let e = null
    switch (elementName) {
      case 'typeHBL': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          props: {
            no: elementName,
            options: [...BILL_TYPES],
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code',
            clearable: false
          },
          convertValue: value => value || 1
        }
        const formCallback = () => { e.hide = this.formData.docType !== 'HBL' }
        this.joinFormWatchList(formCallback)
        formCallback()
        break
      }
      case 'sailingDate': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'lblCfrState': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'billLadingIssued': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'lblReleaseState': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'requestReleaseState': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'releaseEligibleStatus': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'portRequirement': {
        e = {
          elementName,
          component: 'el-input',
          props: {
            type: 'textarea',
            rows: 5
          }
        }
        break
      }
      case 'quantitySum': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'soNo': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'vessel': {
        if (!this.vesselList) {
          this.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
        }
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            selectType: TYPE_NAMES.static_data_Vessel,
            cache: false,
            filterable: true,
            allowCreate: false,
            staticOptions: this.vesselList
          }
        }
        const callback = () => this.editInputVesselModel(e.props)
        this.joinFieldWatchList('job.bookingTerm', callback)
        callback()
        break
      }
      case 'voyageFlight': {
        if (!this.vesselList) {
          this.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
        }
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            cache: false,
            filterable: true,
            clearable: true,
            allowCreate: this.editVoyageMode === 1,
            tagName: 'voyageNo',
            tagValue: 'voyageNo',
            filterTagNames: ['voyageNo'],
            staticOptions: []
          },
          convertValue: value => value || ''
        }
        const callback = () => this.getVoyageByVessel(e.props)
        this.joinFieldWatchList('job.vessel', callback)
        await callback()
        break
      }
      case 'longTermGuaranteeState': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        const formCallback = async() => {
          if (typeof this.formData.longTermGuaranteeState !== 'number') {
            await this.updateGuaranteeStateInfo()
          }
        }
        this.joinFormWatchList(formCallback)
        await formCallback()
        break
      }
      case 'singleTicketGuaranteeState': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        const formCallback = async() => {
          if (typeof this.formData.singleTicketGuaranteeState !== 'number') {
            await this.updateGuaranteeStateInfo()
          }
        }
        this.joinFormWatchList(formCallback)
        await formCallback()
        break
      }
      case 'txtCarrierScAc': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        const callback = () => {
          const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.job.carrierId)
          this.formData.txtCarrierScAc = company ? company.scac : ''
        }
        this.joinFieldWatchList('job.carrierId', callback)
        callback()
        break
      }
      case 'txtBookingAgentScAc': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        const callback = () => {
          const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.job.destinationAgent)
          this.formData.txtBookingAgentScAc = company ? company.scac : ''
        }
        this.joinFieldWatchList('job.destinationAgent', callback)
        callback()
        break
      }
      case 'dispatchingPlaceCode': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/cargoDoc/dispatchingPlaceCode'))?.default,
          props: {}
        }
        const formCallback = () => { e.props.cargoDoc = this.formData }
        this.joinFormWatchList(formCallback)
        formCallback()
        break
      }
      case 'loadingPortCode': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/cargoDoc/loadingPortCode'))?.default,
          props: {}
        }
        const formCallback = () => { e.props.cargoDoc = this.formData }
        this.joinFormWatchList(formCallback)
        formCallback()
        break
      }
      case 'dischargingPortCode': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/cargoDoc/dischargingPortCode'))?.default,
          props: {}
        }
        const formCallback = () => { e.props.cargoDoc = this.formData }
        this.joinFormWatchList(formCallback)
        formCallback()
        break
      }
      case 'destinationPortCode': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/cargoDoc/destinationPortCode'))?.default,
          props: {}
        }
        const formCallback = () => { e.props.cargoDoc = this.formData }
        this.joinFormWatchList(formCallback)
        formCallback()
        break
      }
      case 'freightChargesInfo': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/hbl/freightChargesInfo'))?.default,
          fullWidth: true,
          props: {}
        }
        const jobCallback = () => { e.props.job = this.job }
        const formCallback = () => { e.props.cargoDoc = this.formData }
        this.joinJobWatchList(jobCallback)
        this.joinFormWatchList(formCallback)
        jobCallback()
        formCallback()
        break
      }
    }
    if (e) {
      this.elementMap.set(elementName, e)
    }
    return e
  }

  /**
   * 编辑船名航次模式
   */
  editInputVesselModel(props) {
    props.allowCreate = false
    switch (this.editVesselVoyageMode) {
      case 1:
        props.allowCreate = true
        break
      case 2:
        if (this.job.bookingTerm !== 'OS') {
          props.allowCreate = true
        } else {
          props.allowCreate = false
        }
        break
      case 3:
        props.allowCreate = false
        break
    }
  }

  async getVoyageByVessel(props) {
    props.staticOptions = []
    if (this.job.vessel && this.vesselList) {
      const vessel = this.vesselList.find(item => item.englishName === this.job.vessel)
      if (vessel) {
        props.staticOptions = await Voyage.getVoyage(vessel.vesselId)
      }
    }
  }

  async updateGuaranteeStateInfo() {
    this.formData.longTermGuaranteeState = 0
    this.formData.singleTicketGuaranteeState = 0
    this.formData.guaranteeConfigEnable = false
    if (this.formData.uuid) {
      const guaranteeStateInfo = await getGuaranteeStateInfo({ cargoDocUuid: this.formData.uuid }).then(res => res.data)
      // 长期保函状态：0-无保函，1-生效中，2-已生效
      // 单票保函状态：0-未上传，1-已上传，2-无需上传
      if (guaranteeStateInfo) {
        this.formData.longTermGuaranteeState = guaranteeStateInfo.longTermGuaranteeState
        this.formData.singleTicketGuaranteeState = guaranteeStateInfo.singleTicketGuaranteeState
        this.formData.guaranteeConfigEnable = guaranteeStateInfo.configEnable
      }
    }
  }
}
